import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheetManager } from 'styled-components';
import { ToplevelFigsThemeProvider } from '../../themes/provider';
import { isPropValid } from '../utils/isPropValid';
export function withTheme(children) {
    return (_jsx(StyleSheetManager, { shouldForwardProp: isPropValid, children: _jsx(ToplevelFigsThemeProvider, { children: children }) }));
}
//# sourceMappingURL=withTheme.js.map